import { ReactNode, forwardRef } from 'react';
import {
  RadioInputLabel,
  RadioInputFieldWrapper,
  RadioInputField,
  RadioInputDecor,
  RadioInputTextWrapper,
  RadioInputPrimaryText,
  RadioInputPrimaryTextWrapper,
  RadioInputSecondaryText,
} from './radio-input-new.style';
import { InlineBubble } from 'approot/shared/styles/decorative.style';

type Props = JSX.IntrinsicElements['input'] & {
  label: ReactNode;
  labelUpperElement?: ReactNode;
  isLabelBold?: boolean;
  inlineText?: string;
  description?: ReactNode;
  disabled?: boolean;
  inline?: boolean;
  labelMarginBottom?: number;
  decorMarginRight?: number;
};
const RadioInput = forwardRef(
  (
    {
      label,
      labelUpperElement,
      isLabelBold,
      disabled,
      description,
      inline,
      inlineText,
      labelMarginBottom,
      decorMarginRight,
      ...inputProps
    }: Props,
    ref
  ) => {
    const renderLabel = (
      <RadioInputTextWrapper
        $disabled={disabled}
        $isLabelBold={isLabelBold}
        data-selector="radio-input-label"
      >
        {labelUpperElement}
        <RadioInputPrimaryTextWrapper>
          <RadioInputPrimaryText
            $hasInlineText={!!inlineText}
            data-selector="option-label"
          >
            {label}
          </RadioInputPrimaryText>
          {inlineText && (
            <InlineBubble data-selector="save-pill-text">
              {inlineText}
            </InlineBubble>
          )}{' '}
        </RadioInputPrimaryTextWrapper>
        {description && (
          <RadioInputSecondaryText data-selector="option-description">
            {description}
          </RadioInputSecondaryText>
        )}
      </RadioInputTextWrapper>
    );

    return (
      <RadioInputLabel
        $disabled={disabled}
        $inline={inline}
        htmlFor={inputProps.id}
        $marginBottom={labelMarginBottom}
      >
        {inline && renderLabel}
        {/* Bug in Styled Components types https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451 */}
        <RadioInputFieldWrapper>
          <RadioInputField
            ref={ref as any}
            disabled={disabled}
            type="radio"
            {...inputProps}
          />
          <RadioInputDecor
            $marginRight={decorMarginRight}
            $labelBefore={inline}
          >
            <div />
          </RadioInputDecor>
        </RadioInputFieldWrapper>
        {!inline && renderLabel}
      </RadioInputLabel>
    );
  }
);

export default RadioInput;
